import axios from 'axios'
import Config from "../Config";

export async function bootstrap(id, demoName) {
  return axios.get(`${Config.resourceServer.demoAPI}/bootstrap/${id}/${demoName}`,)
}

export async function getDemos(accessToken) {
  return axios.get(Config.resourceServer.demoAPI + "/demonstration",
    {
      headers: { Authorization: "Bearer " + accessToken }
    }
  )
}

export async function canJoinEvent(accessToken, labContent, eventCode){
  var data = JSON.stringify({
      labContent: labContent,
      eventCode: eventCode?.length > 0 ? eventCode: undefined,
  });
  var config = {
      method: 'post',
      url: Config.resourceServer.demoAPI+ '/events/join',
      headers: {
          'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      data: data
  };
  return axios(config)
}

export async function progressEvent(accessToken, eventCode, demoName, description, progressType){
    var data = JSON.stringify({
      demoName: demoName,
      description: description,
      completedAt: new Date().toISOString(),
      type: progressType
    });
    var config = {
        method: 'patch',
        url: Config.resourceServer.demoAPI+ '/events/'+eventCode+'/progress',
        headers: {
            'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        data: data
    };
  return axios(config)
}

export async function createIDP(accessToken, idpType, variant = 'production') {
  var data = JSON.stringify({
    "type": idpType,
    variant
  });

  var config = {
    method: 'post',
    url: Config.resourceServer.demoAPI + '/idp',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    data: data
  };

  return axios(config)
}

export async function getIDP(accessToken, idpId) {
  return axios.get(`${Config.resourceServer.demoAPI}/idp/${idpId}`,
    { headers: { Authorization: `Bearer ${accessToken}` } }
  )
}

export async function createDemonstration(accessToken, name, type, idpId, source = "labs", eventCode) {
  var data = JSON.stringify({
    name,
    type,
    "idp_id": idpId,
    eventCode
  });

  var config = {
    method: 'post',
    url: Config.resourceServer.demoAPI + '/demonstration',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
      'x-creation-source': source
    },
    data: data
  };

  return axios(config)
}

export async function getDemonstration(accessToken, name) {
  return axios.get(Config.resourceServer.demoAPI + "/demonstration/" + name,
    {
      headers: { 'Authorization': `Bearer ${accessToken}` }
    })
}

export async function deleteDemo(accessToken, name) {
  return axios.delete(`${Config.resourceServer.demoAPI}/demonstration/${name}`,
    {
      headers: { Authorization: `Bearer ${accessToken}` }
    })
}

export async function getComponentInstance(accessToken, demoName, componentId) {
  var config = {
    method: 'get',
    url: Config.resourceServer.demoAPI + '/demonstration/' + demoName + "/components/" + componentId,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    }
  };

  return axios(config)
}

export function attachComponentToDemonstration(accessToken, demoName, appid, label, settings = {}) {
  var data = JSON.stringify({
    componentId: appid,
    label: label,
    settings: settings
  });

  var config = {
    method: 'post',
    url: Config.resourceServer.demoAPI + '/demonstration/' + demoName + "/components",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    data: data
  };

  return axios(config)
}

export function getOpportunities(accessToken) {
  return axios.get(`${Config.resourceServer.demoAPI}/opportunities`,
    {
      headers: { Authorization: `Bearer ${accessToken}` }
    }
  )
}
